export default {
    airport_list : null,
    avaibles : null,
    avaible_15_days:null,
    // selectedSource : null,
    // selectedDestination:null,
    // selectedTicket:null,
    selectedSource : {"code_int":10000,"name_en":"Tehran","name_fa":"تهران","iatA_airport":"THR"},
    selectedDestination:{"code_int":10001,"name_en":"Mashhad","name_fa":"مشهد","iatA_airport":"MHD"},
    selectedTicket:{"ajency_online_ID":446,"type":"system","displayLable":"سیستمی","price_final":9795000,"price_final_chd":0,"price_final_inf":0,"price_final_fare":9142000,"price_final_chd_fare":0,"price_final_inf_fare":0,"capacity":5,"from":"thr","to":"mhd","number_flight":"W51081","type_flight":"Economy","carrier":"Airbus 300-600","date_flight":"2023-01-31","time_flight":"05:55:00","airline":"Mahan","iatA_code":"W5","cabinclass":"BH","weelchairsupport":"YES","linktosite":"charter.charter7-24.com/Ticket-Tehran-Mashhad.html?t=2023-01-31","price_Markup":0,"share_Sale":0,"has_stop":0,"alarm_msg":""},
    ticket_user_info : null,
    captcha : null,
    passengers_count:0
}
